import styled from "@emotion/styled";
import React from "react";

import { BodyM, BodyS } from "@brexhq/shared/components/Typography/Components";
import { SanityCreditCardBlockProps } from "@brexhq/shared/types/modules/BlockRowsModule/BlockRowItems";

type CreditCardBlockDetailsProps = Pick<SanityCreditCardBlockProps, "details">;

const DetailsWrapper = styled.div(({ theme }) => ({
  padding: theme.spacing[24],
  borderTop: `1px solid ${theme.colors.border.default}`,
  display: "grid",
  gridTemplateColumns: "1fr 1fr",
  gap: theme.spacing[24],
}));

const DetailWrapper = styled.div(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: theme.spacing[4],
}));

const DetailLabel = styled(BodyS)(({ theme }) => ({
  color: theme.colors.content.primary,
  fontVariationSettings: `${theme.fonts.FontWeight.BOLD} !important`,
}));

const DetailValue = styled(BodyM)(({ theme }) => ({
  color: theme.colors.content.primary,
}));

export const CreditCardBlockDetails = ({
  details,
}: CreditCardBlockDetailsProps) => {
  if (!Array.isArray(details) || details.length === 0) return null;

  return (
    <DetailsWrapper>
      {details.map((detail, index) => (
        // eslint-disable-next-line react/no-array-index-key
        <DetailWrapper key={`${detail.label}-${index}`}>
          <DetailLabel>{detail.label}</DetailLabel>
          <DetailValue>{detail.value}</DetailValue>
        </DetailWrapper>
      ))}
    </DetailsWrapper>
  );
};
